import EditSvg from '../../../assets/edit.svg?react';
import { IconProps } from '../../types/IconProps';

export function Edit({ size = 20, ...props }: IconProps) {
  return <EditSvg data-testid="edit-icon" width={size} height={size} {...props} />;
}

export default Edit;
